export const AuthenticationRootPath = '/auth';
export const FinancialRootPath = '/dashboard/financial';
export const MenusRootPath = '/dashboard/menus';
export const HelpRootPath = '/help';
export const PoliciesRootPath = '/policies';



// WEBPACK FOOTER //
// ./src/utils/constants/routes.js